/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { useSearchParams } from '@remix-run/react'
import { AuthCodeExchanger } from '~/components/Auth/AuthCodeExchanger'
import { LoginRedirection } from '~/components/Auth/LoginRedirection'

export default function LoginPage() {
  const [searchParams] = useSearchParams()
  const { code, state, error, return_path: returnPath } = Object.fromEntries(searchParams)

  if (!code || !state) {
    return <LoginRedirection returnPath={returnPath} />
  }

  return <AuthCodeExchanger code={code} state={state} error={error} />
}
